export default "__VITE_ASSET__BB3IbFrr__"